/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// @ts-ignore
import type { ConfigurationParameters } from "../configuration";
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from "../configuration";
// @ts-ignore
import type { AxiosError, AxiosResponse } from "axios";
import {
  useQuery,
  UseMutationOptions,
  useMutation,
  UseQueryOptions,
  // @ts-ignore
} from "react-query";
// @ts-ignore
import {
  useAuthorizationToken,
  useAuthQueryKey,
  useApiBasePath,
} from "../../utils";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ImportMode } from "../models";
// @ts-ignore
import { ScheduleImportSummaryDto } from "../models";
// @ts-ignore
import { SsimMessage } from "../models";
/**
 * AirlineFlightScheduleWebServicesApi - axios parameter creator
 * @export
 */
export const AirlineFlightScheduleWebServicesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} token
     * @param {string} from
     * @param {string} to
     * @param {string} format
     * @param {string} [on]
     * @param {string} [since]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSchedule: async (
      token: string,
      from: string,
      to: string,
      format: string,
      on?: string,
      since?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists("exportSchedule", "token", token);
      // verify required parameter 'from' is not null or undefined
      assertParamExists("exportSchedule", "from", from);
      // verify required parameter 'to' is not null or undefined
      assertParamExists("exportSchedule", "to", to);
      // verify required parameter 'format' is not null or undefined
      assertParamExists("exportSchedule", "format", format);
      const localVarPath = `/export/download`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (token !== undefined) {
        localVarQueryParameter["token"] = token;
      }

      if (from !== undefined) {
        localVarQueryParameter["from"] =
          (from as any) instanceof Date
            ? (from as any).toISOString().substr(0, 10)
            : from;
      }

      if (to !== undefined) {
        localVarQueryParameter["to"] =
          (to as any) instanceof Date
            ? (to as any).toISOString().substr(0, 10)
            : to;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      if (on !== undefined) {
        localVarQueryParameter["on"] =
          (on as any) instanceof Date
            ? (on as any).toISOString().substr(0, 10)
            : on;
      }

      if (since !== undefined) {
        localVarQueryParameter["since"] =
          (since as any) instanceof Date
            ? (since as any).toISOString().substr(0, 10)
            : since;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} from
     * @param {string} to
     * @param {string} format
     * @param {string} [on]
     * @param {string} [since]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokenForScheduleExport: async (
      from: string,
      to: string,
      format: string,
      on?: string,
      since?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'from' is not null or undefined
      assertParamExists("getTokenForScheduleExport", "from", from);
      // verify required parameter 'to' is not null or undefined
      assertParamExists("getTokenForScheduleExport", "to", to);
      // verify required parameter 'format' is not null or undefined
      assertParamExists("getTokenForScheduleExport", "format", format);
      const localVarPath = `/export/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (from !== undefined) {
        localVarQueryParameter["from"] =
          (from as any) instanceof Date
            ? (from as any).toISOString().substr(0, 10)
            : from;
      }

      if (to !== undefined) {
        localVarQueryParameter["to"] =
          (to as any) instanceof Date
            ? (to as any).toISOString().substr(0, 10)
            : to;
      }

      if (format !== undefined) {
        localVarQueryParameter["format"] = format;
      }

      if (on !== undefined) {
        localVarQueryParameter["on"] =
          (on as any) instanceof Date
            ? (on as any).toISOString().substr(0, 10)
            : on;
      }

      if (since !== undefined) {
        localVarQueryParameter["since"] =
          (since as any) instanceof Date
            ? (since as any).toISOString().substr(0, 10)
            : since;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} season
     * @param {string} from
     * @param {ImportMode} mode
     * @param {any} file
     * @param {boolean} [localTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFlightScheduleFile: async (
      season: string,
      from: string,
      mode: ImportMode,
      file: any,
      localTime?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'season' is not null or undefined
      assertParamExists("uploadFlightScheduleFile", "season", season);
      // verify required parameter 'from' is not null or undefined
      assertParamExists("uploadFlightScheduleFile", "from", from);
      // verify required parameter 'mode' is not null or undefined
      assertParamExists("uploadFlightScheduleFile", "mode", mode);
      // verify required parameter 'file' is not null or undefined
      assertParamExists("uploadFlightScheduleFile", "file", file);
      const localVarPath = `/import/airlineSchedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (season !== undefined) {
        localVarQueryParameter["season"] = season;
      }

      if (from !== undefined) {
        localVarQueryParameter["from"] =
          (from as any) instanceof Date
            ? (from as any).toISOString().substr(0, 10)
            : from;
      }

      if (mode !== undefined) {
        localVarQueryParameter["mode"] = mode;
      }

      if (localTime !== undefined) {
        localVarQueryParameter["localTime"] = localTime;
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadPartnerFile: async (
      file: any,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists("uploadPartnerFile", "file", file);
      const localVarPath = `/import/partnerSchedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SsimMessage} ssimMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSsimMessage: async (
      ssimMessage: SsimMessage,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'ssimMessage' is not null or undefined
      assertParamExists("uploadSsimMessage", "ssimMessage", ssimMessage);
      const localVarPath = `/import/ssim`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        ssimMessage,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AirlineFlightScheduleWebServicesApi - functional programming interface
 * @export
 */
export const AirlineFlightScheduleWebServicesApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    AirlineFlightScheduleWebServicesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} token
     * @param {string} from
     * @param {string} to
     * @param {string} format
     * @param {string} [on]
     * @param {string} [since]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportSchedule(
      token: string,
      from: string,
      to: string,
      format: string,
      on?: string,
      since?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportSchedule(
        token,
        from,
        to,
        format,
        on,
        since,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} from
     * @param {string} to
     * @param {string} format
     * @param {string} [on]
     * @param {string} [since]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTokenForScheduleExport(
      from: string,
      to: string,
      format: string,
      on?: string,
      since?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getTokenForScheduleExport(
          from,
          to,
          format,
          on,
          since,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} season
     * @param {string} from
     * @param {ImportMode} mode
     * @param {any} file
     * @param {boolean} [localTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadFlightScheduleFile(
      season: string,
      from: string,
      mode: ImportMode,
      file: any,
      localTime?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ScheduleImportSummaryDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.uploadFlightScheduleFile(
          season,
          from,
          mode,
          file,
          localTime,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadPartnerFile(
      file: any,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ScheduleImportSummaryDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.uploadPartnerFile(file, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {SsimMessage} ssimMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadSsimMessage(
      ssimMessage: SsimMessage,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ScheduleImportSummaryDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.uploadSsimMessage(ssimMessage, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
  };
};

/**
 * AirlineFlightScheduleWebServicesApi - factory interface
 * @export
 */
export const AirlineFlightScheduleWebServicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AirlineFlightScheduleWebServicesApiFp(configuration);
  return {
    /**
     *
     * @param {AirlineFlightScheduleWebServicesApiExportScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSchedule(
      requestParameters: AirlineFlightScheduleWebServicesApiExportScheduleRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<any> {
      return localVarFp
        .exportSchedule(
          requestParameters.token,
          requestParameters.from,
          requestParameters.to,
          requestParameters.format,
          requestParameters.on,
          requestParameters.since,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokenForScheduleExport(
      requestParameters: AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .getTokenForScheduleExport(
          requestParameters.from,
          requestParameters.to,
          requestParameters.format,
          requestParameters.on,
          requestParameters.since,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFlightScheduleFile(
      requestParameters: AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<ScheduleImportSummaryDto> {
      return localVarFp
        .uploadFlightScheduleFile(
          requestParameters.season,
          requestParameters.from,
          requestParameters.mode,
          requestParameters.file,
          requestParameters.localTime,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadPartnerFile(
      requestParameters: AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<ScheduleImportSummaryDto> {
      return localVarFp
        .uploadPartnerFile(requestParameters.file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSsimMessage(
      requestParameters: AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<ScheduleImportSummaryDto> {
      return localVarFp
        .uploadSsimMessage(requestParameters.ssimMessage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for exportSchedule operation in AirlineFlightScheduleWebServicesApi.
 * @export
 * @interface AirlineFlightScheduleWebServicesApiExportScheduleRequest
 */
export interface AirlineFlightScheduleWebServicesApiExportScheduleRequest {
  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiExportSchedule
   */
  readonly token: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiExportSchedule
   */
  readonly from: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiExportSchedule
   */
  readonly to: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiExportSchedule
   */
  readonly format: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiExportSchedule
   */
  readonly on?: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiExportSchedule
   */
  readonly since?: string;
}

/**
 * Request parameters for getTokenForScheduleExport operation in AirlineFlightScheduleWebServicesApi.
 * @export
 * @interface AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest
 */
export interface AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest {
  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiGetTokenForScheduleExport
   */
  readonly from: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiGetTokenForScheduleExport
   */
  readonly to: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiGetTokenForScheduleExport
   */
  readonly format: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiGetTokenForScheduleExport
   */
  readonly on?: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiGetTokenForScheduleExport
   */
  readonly since?: string;
}

/**
 * Request parameters for uploadFlightScheduleFile operation in AirlineFlightScheduleWebServicesApi.
 * @export
 * @interface AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest
 */
export interface AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest {
  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiUploadFlightScheduleFile
   */
  readonly season: string;

  /**
   *
   * @type {string}
   * @memberof AirlineFlightScheduleWebServicesApiUploadFlightScheduleFile
   */
  readonly from: string;

  /**
   *
   * @type {ImportMode}
   * @memberof AirlineFlightScheduleWebServicesApiUploadFlightScheduleFile
   */
  readonly mode: ImportMode;

  /**
   *
   * @type {any}
   * @memberof AirlineFlightScheduleWebServicesApiUploadFlightScheduleFile
   */
  readonly file: any;

  /**
   *
   * @type {boolean}
   * @memberof AirlineFlightScheduleWebServicesApiUploadFlightScheduleFile
   */
  readonly localTime?: boolean;
}

/**
 * Request parameters for uploadPartnerFile operation in AirlineFlightScheduleWebServicesApi.
 * @export
 * @interface AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest
 */
export interface AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest {
  /**
   *
   * @type {any}
   * @memberof AirlineFlightScheduleWebServicesApiUploadPartnerFile
   */
  readonly file: any;
}

/**
 * Request parameters for uploadSsimMessage operation in AirlineFlightScheduleWebServicesApi.
 * @export
 * @interface AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest
 */
export interface AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest {
  /**
   *
   * @type {SsimMessage}
   * @memberof AirlineFlightScheduleWebServicesApiUploadSsimMessage
   */
  readonly ssimMessage: SsimMessage;
}

/**
 * AirlineFlightScheduleWebServicesApi - object-oriented interface
 * @export
 * @class AirlineFlightScheduleWebServicesApi
 * @extends {BaseAPI}
 */
export class AirlineFlightScheduleWebServicesApi extends BaseAPI {
  /**
   *
   * @param {AirlineFlightScheduleWebServicesApiExportScheduleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AirlineFlightScheduleWebServicesApi
   */
  public exportSchedule(
    requestParameters: AirlineFlightScheduleWebServicesApiExportScheduleRequest,
    options?: AxiosRequestConfig
  ) {
    return AirlineFlightScheduleWebServicesApiFp(this.configuration)
      .exportSchedule(
        requestParameters.token,
        requestParameters.from,
        requestParameters.to,
        requestParameters.format,
        requestParameters.on,
        requestParameters.since,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AirlineFlightScheduleWebServicesApi
   */
  public getTokenForScheduleExport(
    requestParameters: AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest,
    options?: AxiosRequestConfig
  ) {
    return AirlineFlightScheduleWebServicesApiFp(this.configuration)
      .getTokenForScheduleExport(
        requestParameters.from,
        requestParameters.to,
        requestParameters.format,
        requestParameters.on,
        requestParameters.since,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AirlineFlightScheduleWebServicesApi
   */
  public uploadFlightScheduleFile(
    requestParameters: AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest,
    options?: AxiosRequestConfig
  ) {
    return AirlineFlightScheduleWebServicesApiFp(this.configuration)
      .uploadFlightScheduleFile(
        requestParameters.season,
        requestParameters.from,
        requestParameters.mode,
        requestParameters.file,
        requestParameters.localTime,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AirlineFlightScheduleWebServicesApi
   */
  public uploadPartnerFile(
    requestParameters: AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest,
    options?: AxiosRequestConfig
  ) {
    return AirlineFlightScheduleWebServicesApiFp(this.configuration)
      .uploadPartnerFile(requestParameters.file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AirlineFlightScheduleWebServicesApi
   */
  public uploadSsimMessage(
    requestParameters: AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest,
    options?: AxiosRequestConfig
  ) {
    return AirlineFlightScheduleWebServicesApiFp(this.configuration)
      .uploadSsimMessage(requestParameters.ssimMessage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

// custom hook generation here
export type GetExportScheduleResponse = AxiosResponse<any>;
export const KeyGetExportSchedule = "GetExportSchedule";
export const useMutationGetExportSchedule = (
  options?: UseMutationOptions<
    GetExportScheduleResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiExportScheduleRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetExportScheduleResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiExportScheduleRequest
  >(
    (args: AirlineFlightScheduleWebServicesApiExportScheduleRequest) =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).exportSchedule(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetExportSchedule = (
  args: AirlineFlightScheduleWebServicesApiExportScheduleRequest,
  options?: UseQueryOptions<GetExportScheduleResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetExportScheduleResponse, AxiosError>(
    [KeyGetExportSchedule, args, options && options.queryKey, authQueryKey],
    () =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).exportSchedule(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetTokenForScheduleExportResponse = AxiosResponse<string>;
export const KeyGetGetTokenForScheduleExport = "GetGetTokenForScheduleExport";
export const useMutationGetGetTokenForScheduleExport = (
  options?: UseMutationOptions<
    GetGetTokenForScheduleExportResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetGetTokenForScheduleExportResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest
  >(
    (
      args: AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest
    ) =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getTokenForScheduleExport(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetTokenForScheduleExport = (
  args: AirlineFlightScheduleWebServicesApiGetTokenForScheduleExportRequest,
  options?: UseQueryOptions<GetGetTokenForScheduleExportResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetTokenForScheduleExportResponse, AxiosError>(
    [
      KeyGetGetTokenForScheduleExport,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getTokenForScheduleExport(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostUploadFlightScheduleFileResponse =
  AxiosResponse<ScheduleImportSummaryDto>;
export const KeyPostUploadFlightScheduleFile = "PostUploadFlightScheduleFile";
export const useMutationPostUploadFlightScheduleFile = (
  options?: UseMutationOptions<
    PostUploadFlightScheduleFileResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostUploadFlightScheduleFileResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest
  >(
    (
      args: AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest
    ) =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).uploadFlightScheduleFile(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostUploadFlightScheduleFile = (
  args: AirlineFlightScheduleWebServicesApiUploadFlightScheduleFileRequest,
  options?: UseQueryOptions<PostUploadFlightScheduleFileResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostUploadFlightScheduleFileResponse, AxiosError>(
    [
      KeyPostUploadFlightScheduleFile,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).uploadFlightScheduleFile(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostUploadPartnerFileResponse =
  AxiosResponse<ScheduleImportSummaryDto>;
export const KeyPostUploadPartnerFile = "PostUploadPartnerFile";
export const useMutationPostUploadPartnerFile = (
  options?: UseMutationOptions<
    PostUploadPartnerFileResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostUploadPartnerFileResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest
  >(
    (args: AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest) =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).uploadPartnerFile(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostUploadPartnerFile = (
  args: AirlineFlightScheduleWebServicesApiUploadPartnerFileRequest,
  options?: UseQueryOptions<PostUploadPartnerFileResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostUploadPartnerFileResponse, AxiosError>(
    [KeyPostUploadPartnerFile, args, options && options.queryKey, authQueryKey],
    () =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).uploadPartnerFile(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostUploadSsimMessageResponse =
  AxiosResponse<ScheduleImportSummaryDto>;
export const KeyPostUploadSsimMessage = "PostUploadSsimMessage";
export const useMutationPostUploadSsimMessage = (
  options?: UseMutationOptions<
    PostUploadSsimMessageResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostUploadSsimMessageResponse,
    AxiosError,
    AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest
  >(
    (args: AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest) =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).uploadSsimMessage(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostUploadSsimMessage = (
  args: AirlineFlightScheduleWebServicesApiUploadSsimMessageRequest,
  options?: UseQueryOptions<PostUploadSsimMessageResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostUploadSsimMessageResponse, AxiosError>(
    [KeyPostUploadSsimMessage, args, options && options.queryKey, authQueryKey],
    () =>
      new AirlineFlightScheduleWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).uploadSsimMessage(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
